export function hourCalculaater(inTimeStr, outTimeStr) {
    // const inTimeStr = "19:56:31.666";
    // const outTimeStr = "20:07:26.231";

    // Convert to Date objects (assume same day)
    const today = new Date().toISOString().split("T")[0]; // e.g., "2025-12-23"
    const inTime = new Date(`${today}T${inTimeStr}`);
    const outTime = new Date(`${today}T${outTimeStr}`);

    // Handle overnight shift
    if (outTime < inTime) {
        outTime.setDate(outTime.getDate() + 1);
    }

    // Calculate difference in milliseconds
    const diffMs = outTime - inTime;

    // Convert to hours, minutes, seconds
    const diffSeconds = Math.floor(diffMs / 1000);
    const hours = Math.floor(diffSeconds / 3600);
    const minutes = Math.floor((diffSeconds % 3600) / 60);
    const seconds = diffSeconds % 60;

    console.log(`${hours} hrs ${minutes} mins ${seconds} secs`);
    return `${hours}:${minutes}:${seconds}`;
}